export default __webpack_public_path__ + "static/media/delay-dark.80ea2efe.svg";